

.background {
  background-color: rgb(129, 129, 129);
  position: absolute;
  width: 100%;
  height: 100%;

  opacity: 0;
  transition: opacity 3s;

  pointer-events: none;
}

.background.ready {
  opacity: 1;
}